/**
 * Hardcoded homepage resource cards (not from CMS).
 * Icons live in /images/resources/ (public folder).
 */
export const STATIC_FEATURED_RESOURCES = [
  {
    id: 'scam-alerts',
    path: '/resources/scam-alerts',
    title: 'Scam Alerts — Protect Yourself',
    description:
      'See which companies and programs regulators and credible sources have warned about—and how to report fraud and submit a claim if you were affected.',
    iconSrc: '/images/resources/scam_alerticon.jpg',
    iconAlt: 'Scam alert',
  },
  {
    id: 'refund-programs',
    path: '/resources/refund-programs',
    title: 'Averadao Refund Programs',
    description:
      'Active refund programs we help administer, how eligibility works, and why Averadao will never charge you or ask you to wire money to "process" a claim.',
    iconSrc: '/images/resources/Refund_program_icon.png',
    iconAlt: 'Refund programs',
  },
  {
    id: 'how-refunds',
    path: '/resources/how-refunds-work',
    title: 'How Averadao Provides Refunds',
    description:
      'From building a reliable customer list to mailing checks and closing programs—six steps we follow to get money back to injured consumers.',
    iconSrc: '/images/resources/how_dao_offer_refund_icon.jpg',
    iconAlt: 'How refunds work',
  },

];
